
document.addEventListener('DOMContentLoaded', function () {
    require('./menu-mobile.js');
    require('./map.js');
    require('./edit-map.js');
    require('./copy-iframe.js');
    require('./map-share.js');
    require('./pdf-generate.js');
    // require('./toast.js');

    const copyButtons = document.querySelectorAll(".btn-copy-link");
    copyButtons.forEach(button => {
        button.addEventListener("click", () => {
            const text = button.getAttribute("data-clipboard-text");

            // Copier dans le presse-papier
            navigator.clipboard.writeText(text).then(() => {
                // Switch icons
                const svgCopy = button.querySelector(".svg-copy");
                const svgCheck = button.querySelector(".svg-check");

                svgCopy.classList.add("hidden");
                svgCheck.classList.remove("hidden");

                // Revenir après 2 secondes
                setTimeout(() => {
                    svgCopy.classList.remove("hidden");
                    svgCheck.classList.add("hidden");
                }, 2000);
            }).catch(err => {
                console.error("Erreur lors de la copie : ", err);
            });
        });
    });


    class FileUploadManager {
        constructor(options = {}) {
            this.fileUploadId = options.fileUploadId || 'fileUpload';
            this.fileInputId = options.fileInputId || 'fileInput';
            this.fileListId = options.fileListId || 'fileList';
            this.existingFiles = options.existingFiles || [];
            
            // DOM elements
            this.fileUpload = document.getElementById(this.fileUploadId);
            this.fileInput = document.getElementById(this.fileInputId);
            this.fileList = document.getElementById(this.fileListId);
            
            // Initialize files array
            this.files = Array.isArray(this.existingFiles) ? this.existingFiles.slice() : [];
            
            if (this.fileUpload && this.fileInput && this.fileList) {
                this.init();
            }
        }
        
        init() {
            this.bindEvents();
            this.updateFileList();
        }
        
        bindEvents() {
            // Click to open file picker
            this.fileUpload.addEventListener('click', () => this.fileInput.click());
            
            // Drag & drop events
            this.fileUpload.addEventListener('dragover', (e) => this.handleDragOver(e));
            this.fileUpload.addEventListener('dragleave', () => this.handleDragLeave());
            this.fileUpload.addEventListener('drop', (e) => this.handleDrop(e));
            
            // File input change
            this.fileInput.addEventListener('change', () => this.handleFiles(this.fileInput.files));
        }
        
        handleDragOver(e) {
            e.preventDefault();
            this.fileUpload.classList.add('dragover');
        }
        
        handleDragLeave() {
            this.fileUpload.classList.remove('dragover');
        }
        
        handleDrop(e) {
            e.preventDefault();
            this.fileUpload.classList.remove('dragover');
            this.handleFiles(e.dataTransfer.files);
        }
        
        handleFiles(fileList) {
            for (let f of fileList) {
                this.files.push({ fileObj: f, name: f.name });
            }
            this.updateFileList();
        }
        
        removeFile(index) {
            this.files.splice(index, 1);
            this.updateFileList();
        }
        
        updateFileList() {
            this.fileList.innerHTML = '';
            this.files.forEach((file, idx) => {
                const el = document.createElement('div');
                el.className = 'file-item';
                el.innerHTML = `
                    <span>${file.url ? `<a href="${file.url}" target="_blank">${file.name}</a>` : file.name}</span>
                    <button data-idx="${idx}" class="btn-primary" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" width="15" height="15" class="fill-white">
                            <path d="M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z" />
                        </svg>
                    </button>
                    ${file.isCustom ? `<input type="hidden" name="existing_files[]" value="${encodeURIComponent(file.name)}">` : ''}
                `;
                
                // Add remove event listener
                el.querySelector('button').addEventListener('click', () => this.removeFile(idx));
                this.fileList.appendChild(el);
            });
        }
        
        // Public methods
        getFiles() {
            return this.files;
        }
        
        clearFiles() {
            this.files = [];
            this.updateFileList();
        }
        
        addFile(file) {
            this.files.push(file);
            this.updateFileList();
        }
    }

    const upladerFiler = document.getElementById('fileUpload');

    if (upladerFiler) {
        $param = (typeof WPData !== 'undefined') ? {existingFiles: WPData.postDocuments || []} : {};
        const editFormUploader = new FileUploadManager($param);
    }

});